<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Alterar Senha' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <ion-card class="gradient-extendido-recuo">
    <ion-card-content>

      <form class="sample-form validations-form" [formGroup]="validations_form"
        (ngSubmit)="onSubmit(validations_form.value)">
        <ion-item>
          <ion-label position="stacked">{{'Senha Atual' | translate}} <span class="danger">*</span></ion-label>
          <ion-input formControlName="senhaatual" name="senhaatual" type="password">
          </ion-input>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.senhaatual">
            <div class="error-message"
              *ngIf="validations_form.get('senhaatual')?.hasError(validation.type) && (validations_form.get('senhaatual')?.dirty || validations_form.get('senhaatual')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ion-item>
          <ion-label position="stacked">{{'Nova Senha' | translate}} <span class="danger">*</span></ion-label>
          <ion-input formControlName="senha" name="senha" type="password">
          </ion-input>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.senha">
            <div class="error-message"
              *ngIf="validations_form.get('senha')?.hasError(validation.type) && (validations_form.get('senha')?.dirty || validations_form.get('senha')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ion-item>
          <ion-label position="stacked">{{'Confirmar Nova Senha' | translate}} <span class="danger">*</span></ion-label>
          <ion-input formControlName="confirmaSenha" name="confirmaSenha" type="password">
          </ion-input>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.confirmaSenha">
            <div class="error-message"
              *ngIf="validations_form.get('confirmaSenha')?.hasError(validation.type) && (validations_form.get('confirmaSenha')?.dirty || validations_form.get('confirmaSenha')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <div [hidden]="!erro_senha" class="validation-errors">
          <div class="error-message">
            {{'As senhas não batem' | translate}}
          </div>
        </div>

        <div class="down">
          <ion-button expand="block" class="btn-prover" type="submit" [disabled]="!validations_form.valid">{{'Alterar' |
            translate}}</ion-button>
        </div>
      </form>
    </ion-card-content>
  </ion-card>
</ion-content>